<template>
  <p class="debug">loading = {{loading}}</p>
  <!--form for invoice object-->
  <div class="container">
    <div v-if="loading">
      Loading invoice create form...
    </div>
    <MyForm v-else :title="'New Invoice Form'">
      <template v-slot:fields>
        <!--Form-input v-model="props.index" :readonly=true :disabled=true :name="'index:'"></Form-input-->
        <!--Form-input v-model="mInvoice.id" :readonly=true :disabled=true :name="'invoice no:'"></Form-input-->
        <!--Form-input v-model="mInvoice.created_by" :readonly=true :disabled=true
                    :name="'created by:'"></Form-input>
                <Form-input v-model="mInvoice.created_on" :readonly=true :disabled=true
                    :name="'created on:'"></Form-input>
                <Form-input v-model="mInvoice.modified_on" :readonly=true :disabled=true
                    :name="'modified on:'"></Form-input>
                <Form-input v-model="mInvoice.projectId" :readonly=true :disabled=true
                    :name="'project id:'"></Form-input>-->
        <UserSelect
          v-model:selected="mInvoice.owner_id"
          :name="'Owner:'"
          :role="'owner'"
          :includeArchived="false"
        ></UserSelect>
        <UserSelect
          v-model:selected="mInvoice.engineer_id"
          :name="'Engineer:'"
          :role="'engineer'"
          :includeArchived="false"
        ></UserSelect>
<!--
        <Form-input
          v-model="mInvoice.address"
          :readonly="true"
          :disabled="true"
          :name="'address:'"
        ></Form-input>
        <Form-input
          v-model="mInvoice.province"
          :readonly="true"
          :disabled="true"
          :name="'province:'"
        ></Form-input>
        <Form-input
          v-model="mInvoice.taxRate"
          :readonly="true"
          :disabled="true"
          :name="'tax rate:'"
        ></Form-input> -->
        <!--FormDatepicker v-model="mInvoice.datePaid" :name="'date paid:'"></FormDatepicker>-->

        <!--CustomerSelect v-model:selected="mInvoice.customer.id"></CustomerSelect-->
        <CustomerListbox v-model:customer="mInvoice.customer"></CustomerListbox>
        <FormSelect
          :name="'Job Rate:'"
          :options="jobRateOptions"
          :displayOptions="jobRateDisplayOptions"
          v-model:selected="jobRate"
        ></FormSelect>

        <LineItemsTable
          :taxRate="mInvoice.taxRate"
          v-model:netValue="mInvoice.valueTotal"
          v-model:netTax="mInvoice.taxTotal"
          v-model:lineItems="mInvoice.lineItems"
          v-model:jobRate="jobRate.value"
        ></LineItemsTable>
      </template>

      <template v-slot:buttons>
        <div class="form-btns">
          <!--FormBtn :name="'Submit'" @clicked="emits('submitForm', 'mInvoice')"></FormBtn-->
          <FormBtn :name="'Submit'" @clicked="submitForm"></FormBtn>
          <!--FormBtn :name="'Revert'" @clicked="emits('revertForm', 'mInvoice')"></FormBtn-->
          <FormBtn :name="'Cancel'" @clicked="cancelForm"></FormBtn>
          <!--FormBtn :name="'Delete Invoice'" @clicked="deleteInvoice"></FormBtn-->
          <!--button type="button" class="btn btn-primary" @click="emits('submitForm','mInvoice')">Submit</button>
                    <button type="button" class="btn btn-warning" @click="emits('revertForm')">Revert Changes</button>-->
        </div>
      </template>
    </MyForm>

    
        <div class="debug">
            <b>Within Invoice-create.vue:</b>
            <p>reactive mInvoice:</p>
            <p v-for="(value, key) in mInvoice" :key="key">{{key}}: {{ value }}</p>

        </div>
    
  </div>
</template>

<script setup lang="ts">
import { computed, ref } from 'vue'
import LineItemsTable from '@/views/projects/invoices/Lineitems-table.vue'
import { MyForm, FormInput, FormSelect, FormBtn, UserSelect } from '@/components/form'
import type { Invoice, Project } from '@/types/types'
import CustomerListbox from '@/components/Customer-listbox.vue';
import { useInvoiceStore, useProjectStore, useUserStore, useAlertStore , useRatesStore} from '@/stores'
import router from '@/router'
import { TaxOptions } from '@/types/types'
import { useCurrentProject } from '@/composables/Current-project';

const userStore = useUserStore()
const invoices = useInvoiceStore()
const { currentProject, loading } = useCurrentProject();
const { jobRateOptions } = useRatesStore();
const jobRateDisplayOptions = jobRateOptions.map((item) => {
  return item.name
})
const jobRate = ref(jobRateOptions[0])

/*const tax = computed(() =>{
  return TaxOptions[currentProject.value.province];
})*/
//start with blank invoice
const emptyInv = computed(() =>{
  console.log("...within emptyInv computed, currentProject=  " + JSON.stringify(currentProject.value));
  const tax = TaxOptions[currentProject.value.province];
  //const tax = TaxOptions['AB'];
  const inv = {
    created_by: userStore.currentEmail,
    projectId: currentProject.value.id,
    address: `${currentProject.value.streetAddress}, ${currentProject.value.city}, ${currentProject.value.province}`,
    customer_id : currentProject.value.customer_id,
    customer: currentProject.value.customer,
    province: currentProject.value.province,
    taxRate: tax.rate,
    //datePaid : null,
    lineItems: [],
    owner_id: currentProject.value.owner_id, //userStore.currentEmail
    engineer_id : currentProject.value.engineer_id
  }
  console.log("...emptyInv computed..." + JSON.stringify(inv));
  return inv;
})
const mInvoice = ref<Invoice>(JSON.parse(JSON.stringify(emptyInv.value))) //{ id: props.invoiceId, 'lineItems': [{ 'value': 0, 'description': 'empty', 'tax': 0 }] });

/*
const mInvoice = computed(()=>{
  //const tax = TaxOptions[currentProject.value.province];
  const tax = TaxOptions['AB'];
  return {
    created_by: userStore.currentEmail,
    projectId: currentProject.value.id,
    address: `${currentProject.value.streetAddress}, ${currentProject.value.city}, ${currentProject.value.province}`,
    //customerId : proj.customer.id,
    customer: currentProject.value.customer,
    province: currentProject.value.province,
    taxRate: tax.rate,
    //datePaid : null,
    lineItems: [],
    owner: currentProject.value.engineer //userStore.currentEmail
  }
})*/


/**
 * create the invoice on the backend
 * TODO is router push necessary?
 */
async function submitForm() {
  console.log('invoice create form submitted...')
  console.log('...mInvoice = ' + JSON.stringify(mInvoice.value));
  //delete mInvoice.value['engineer'];
  await invoices.createInvoice(mInvoice.value);
 
}

/**
 * revert the form to db value
 * TODO router.push doesnt seem to reload the 'page'
 */
async function cancelForm() {
  console.log('invoice create form cancelled...')
  //router.push(`/projects/${props.projectId}/invoices`);
  router.push(`/projects/${currentProject.value.id}/invoices`)
  /*router.push({
        name: 'project_invoices'
        
    });*/
  //await fetchInvoice();
}

/**
 * delete the invoice from db
 *
async function deleteInvoice(){
    console.log("invoice form delete called...");
    const projId = mInvoice.value?.projectId;
    const invId = mInvoice.value.id;
    const response = await invoices.deleteInvoice(invId);
    console.log("...response = " + response);
    router.push(`/projects/${projId}}/invoices/`);
}
*/
//const jobRate = ref(1);

/**
 * compute the net (total) value of invoice entries
 */
const netValue = computed(() => {
  console.log('Invoice-form.netValue computing..')
  let total = 0
  try {
    mInvoice.value.lineItems.items.forEach((entry) => {
      total += Number(entry.value)
    })
  } catch (err) {
    console.log('...lineItems has no values...')
  }
  return formatDollars(total)
})

/**
 * compute the net (total) value of tax
 */
const netTax = computed(() => {
  console.log('Invoice-form.netValue computing..')
  return formatDollars(netValue.value * mInvoice.value.taxRate)
})

/**
 * format the number into 2 decimal places max
 * @param {Number} num
 */
function formatDollars(num: number) {
  return Math.round(num * 100) / 100
}
</script>
